import extractPhoneContext, { isPhoneContextValid, PLUS_SIGN, RFC3966_PREFIX_, RFC3966_PHONE_CONTEXT_, RFC3966_ISDN_SUBADDRESS_ } from "./extractPhoneContext.js";
import ParseError from "../ParseError.js";
function extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(numberToParse, _ref) {
  var extractFormattedPhoneNumber = _ref.extractFormattedPhoneNumber, phoneContext = extractPhoneContext(numberToParse);
  if (!isPhoneContextValid(phoneContext))
    throw new ParseError("NOT_A_NUMBER");
  var phoneNumberString;
  if (phoneContext === null)
    phoneNumberString = extractFormattedPhoneNumber(numberToParse) || "";
  else {
    phoneNumberString = "", phoneContext.charAt(0) === PLUS_SIGN && (phoneNumberString += phoneContext);
    var indexOfRfc3966Prefix = numberToParse.indexOf(RFC3966_PREFIX_), indexOfNationalNumber;
    indexOfRfc3966Prefix >= 0 ? indexOfNationalNumber = indexOfRfc3966Prefix + RFC3966_PREFIX_.length : indexOfNationalNumber = 0;
    var indexOfPhoneContext = numberToParse.indexOf(RFC3966_PHONE_CONTEXT_);
    phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
  }
  var indexOfIsdn = phoneNumberString.indexOf(RFC3966_ISDN_SUBADDRESS_);
  if (indexOfIsdn > 0 && (phoneNumberString = phoneNumberString.substring(0, indexOfIsdn)), phoneNumberString !== "")
    return phoneNumberString;
}
export {
  extractFormattedPhoneNumberFromPossibleRfc3966NumberUri as default
};
//# sourceMappingURL=extractFormattedPhoneNumberFromPossibleRfc3966NumberUri.js.map
